import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, type OnDestroy, type OnInit } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ConfigResourceService } from '../../services/config-resource.service';
import { ResourceTemplateComponent } from '../../shared/resource-template/resource-template.component';

@Component({
  selector: 'app-terms-of-service',
  templateUrl: './terms-of-service.component.html',
  styleUrls: ['./terms-of-service.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, MatDialogModule, ResourceTemplateComponent]
})
export class TermsOfServiceComponent implements OnInit, OnDestroy {
  @Input() footerStickyEnabled: boolean = true;

  termsContent: string = '';
  private readonly subscriptions: Subscription = new Subscription();

  constructor(private readonly configService: ConfigResourceService, private readonly cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.configService.configLoaded$.subscribe({
        next: loaded => {
          if (loaded) {
            this.termsContent = this.configService.getProcessedResourceValue<string>(
              'Spa_Site_TermsOfUse_Body',
              '<h1>[[Spa_Site_TermsOfUse]]</h1>'
            );
            this.cdr.markForCheck();
          }
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
